import { render, staticRenderFns } from "./userPortTab.vue?vue&type=template&id=2b17958b&"
import script from "./userPortTab.vue?vue&type=script&lang=js&"
export * from "./userPortTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b17958b')) {
      api.createRecord('2b17958b', component.options)
    } else {
      api.reload('2b17958b', component.options)
    }
    module.hot.accept("./userPortTab.vue?vue&type=template&id=2b17958b&", function () {
      api.rerender('2b17958b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/user/userPortTab.vue"
export default component.exports